import FeedbackIcon from '@mui/icons-material/Feedback'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Button, Card, Grid, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

const PerkSuggestionBanner = () => {
  const theme = useTheme()
  return (
    <Grid item xs={12} sm={12} md={6} lg={4} sx={{ display: 'flex' }}>
      <Card
        sx={{
          width: '100%',
          height: '325px',
          minHeight: '325px',
          backgroundColor: theme.palette.accentYellow[50],
          boxSizing: 'border-box',
          border: `1px solid ${theme.palette.accentYellow[400]}`,
          padding: '16px',
          color: theme.palette.accentYellow[900],
          '& a': {
            color: 'inherit',
          },
          textAlign: 'start',
        }}
      >
        <Grid
          container
          height="100%"
          flexDirection={'column'}
          justifyContent={'space-between'}
        >
          <Grid
            item
            display="flex"
            alignItems="center"
            justifyContent={'flex-start'}
          >
            <FeedbackIcon
              fontSize="large"
              sx={{
                fill: theme.palette.accentYellow[500],
                marginRight: '16px',
              }}
            />
            <Typography
              variant="h6"
              color={theme.palette.accentYellow[900]}
              sx={{ fontWeight: 600 }}
            >
              Suggest a Perk
            </Typography>
          </Grid>
          <Typography component="div" variant="body2">
            Is there a perk you'd like to see that isn't here?
          </Typography>
          <Typography component="div" variant="body2">
            Know of an awesome company that can help your fellow founders save
            money?
          </Typography>
          <Typography component="div" variant="body2">
            Let us know.
          </Typography>
          <Grid
            item
            display={'flex'}
            gap={'16px'}
            flexDirection={'column'}
            mt="16px"
          />
          <Grid item alignSelf={'flex-end'}>
            <Button
              href="https://forms.gle/2m3i3x1nAc3hLQsW7"
              target="_blank"
              size="small"
              sx={{ color: theme.palette.accentYellow[900] }}
              endIcon={<OpenInNewIcon />}
            >
              Suggest a Perk
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  )
}

export default PerkSuggestionBanner
